import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/header.css';

const Header = () => {
  const { currentUser, userProfile, signOut } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleLogout = async () => {
    await signOut();
    navigate('/');
    setShowDropdown(false);
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
  };

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      background: 'white',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      zIndex: 1000
    }}>
      <nav style={{
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '0 1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '4rem'
      }}>
        <div>
          <Link to="/">
            <img src="/images/logo.png" alt="Offer Lifetime Logo" style={{ height: '50px' }} />
          </Link>
        </div>

        {/* Hamburger Menu Button - Mobile Only */}
        {isMobile && (
          <button 
            onClick={() => setShowMobileMenu(!showMobileMenu)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px'
            }}
          >
            <span style={{ width: '24px', height: '3px', background: '#1e3a8a', borderRadius: '2px', transition: 'all 0.3s' }}></span>
            <span style={{ width: '24px', height: '3px', background: '#1e3a8a', borderRadius: '2px', transition: 'all 0.3s' }}></span>
            <span style={{ width: '24px', height: '3px', background: '#1e3a8a', borderRadius: '2px', transition: 'all 0.3s' }}></span>
          </button>
        )}

        <div className="header-nav" style={{ display: isMobile ? 'none' : 'flex' }}>
          <a href="#home" className="nav-link">Home</a>
          <a href="#about" className="nav-link">About</a>
          <a href="#participate" className="nav-link">How to Participate</a>
          <a href="#prizes" className="nav-link">Prizes</a>
          <a href="#winners" className="nav-link">Winners</a>
          <a href="#contact" className="nav-link">Contact</a>
          
          {currentUser ? (
            <div 
              className="profile-dropdown-container"
              onMouseEnter={() => !isMobile && setShowDropdown(true)}
              onMouseLeave={() => !isMobile && setShowDropdown(false)}
            >
              <button 
                className="profile-button"
                onClick={() => isMobile && setShowDropdown(!showDropdown)}
              >
                {userProfile?.profileImage ? (
                  <img 
                    src={userProfile.profileImage} 
                    alt={userProfile.name}
                    className="profile-avatar"
                  />
                ) : (
                  <div className="profile-avatar-placeholder">
                    {getInitials(userProfile?.name || currentUser?.displayName)}
                  </div>
                )}
                <span className="profile-name">
                  {userProfile?.name || currentUser?.displayName || 'User'}
                </span>
                <svg 
                  className={`dropdown-arrow ${showDropdown ? 'open' : ''}`}
                  width="16" 
                  height="16" 
                  viewBox="0 0 16 16" 
                  fill="currentColor"
                >
                  <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>

              {showDropdown && (
                <div className="profile-dropdown">
                  <div className="dropdown-header">
                    <div className="dropdown-user-info">
                      {userProfile?.profileImage ? (
                        <img 
                          src={userProfile.profileImage} 
                          alt={userProfile.name}
                          className="dropdown-avatar"
                        />
                      ) : (
                        <div className="dropdown-avatar-placeholder">
                          {getInitials(userProfile?.name || currentUser?.displayName)}
                        </div>
                      )}
                      <div>
                        <p className="dropdown-name">{userProfile?.name || currentUser?.displayName || 'User'}</p>
                        <p className="dropdown-email">{currentUser?.email}</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="dropdown-divider"></div>
                  
                  <Link 
                    to="/dashboard" 
                    className="dropdown-item"
                    onClick={() => setShowDropdown(false)}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="3" width="7" height="7"></rect>
                      <rect x="14" y="3" width="7" height="7"></rect>
                      <rect x="14" y="14" width="7" height="7"></rect>
                      <rect x="3" y="14" width="7" height="7"></rect>
                    </svg>
                    <span>Dashboard</span>
                  </Link>
                  
                  <button 
                    className="dropdown-item logout-item"
                    onClick={handleLogout}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                      <polyline points="16 17 21 12 16 7"></polyline>
                      <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                    <span>Logout</span>
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/register" className="btn-primary">
              Get VIP Token
            </Link>
          )}
        </div>

        {/* Mobile Dropdown Menu */}
        {isMobile && showMobileMenu && (
          <div style={{
            position: 'absolute',
            top: '4rem',
            right: '1rem',
            background: 'white',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
            borderRadius: '12px',
            padding: '0.5rem',
            zIndex: 999,
            minWidth: '240px',
            maxWidth: '280px',
            border: '1px solid #e2e8f0',
            animation: 'dropdownSlide 0.2s ease-out'
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
              <a 
                href="#home" 
                className="nav-link" 
                onClick={() => setShowMobileMenu(false)}
                style={{ 
                  padding: '0.75rem 1rem', 
                  borderRadius: '8px',
                  transition: 'background 0.2s',
                  fontSize: '0.875rem',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                Home
              </a>
              <a 
                href="#about" 
                className="nav-link"
                onClick={() => setShowMobileMenu(false)}
                style={{ 
                  padding: '0.75rem 1rem', 
                  borderRadius: '8px',
                  transition: 'background 0.2s',
                  fontSize: '0.875rem',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                About
              </a>
              <a 
                href="#participate" 
                className="nav-link"
                onClick={() => setShowMobileMenu(false)}
                style={{ 
                  padding: '0.75rem 1rem', 
                  borderRadius: '8px',
                  transition: 'background 0.2s',
                  fontSize: '0.875rem',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                How to Participate
              </a>
              <a 
                href="#prizes" 
                className="nav-link"
                onClick={() => setShowMobileMenu(false)}
                style={{ 
                  padding: '0.75rem 1rem', 
                  borderRadius: '8px',
                  transition: 'background 0.2s',
                  fontSize: '0.875rem',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                Prizes
              </a>
              <a 
                href="#winners" 
                className="nav-link"
                onClick={() => setShowMobileMenu(false)}
                style={{ 
                  padding: '0.75rem 1rem', 
                  borderRadius: '8px',
                  transition: 'background 0.2s',
                  fontSize: '0.875rem',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                Winners
              </a>
              <a 
                href="#contact" 
                className="nav-link"
                onClick={() => setShowMobileMenu(false)}
                style={{ 
                  padding: '0.75rem 1rem', 
                  borderRadius: '8px',
                  transition: 'background 0.2s',
                  fontSize: '0.875rem',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                Contact
              </a>
              
              <div style={{ height: '1px', background: '#e2e8f0', margin: '0.5rem 0' }}></div>
              
              {currentUser ? (
                <>
                  <Link 
                    to="/dashboard" 
                    className="nav-link"
                    onClick={() => setShowMobileMenu(false)}
                    style={{ 
                      padding: '0.75rem 1rem', 
                      borderRadius: '8px',
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '0.5rem',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      transition: 'background 0.2s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="3" width="7" height="7"></rect>
                      <rect x="14" y="3" width="7" height="7"></rect>
                      <rect x="14" y="14" width="7" height="7"></rect>
                      <rect x="3" y="14" width="7" height="7"></rect>
                    </svg>
                    Dashboard
                  </Link>
                  <button 
                    onClick={handleLogout}
                    style={{
                      padding: '0.75rem 1rem',
                      background: 'none',
                      border: 'none',
                      textAlign: 'left',
                      cursor: 'pointer',
                      color: '#dc2626',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      borderRadius: '8px',
                      fontSize: '0.875rem',
                      transition: 'background 0.2s',
                      width: '100%'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#fef2f2'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                      <polyline points="16 17 21 12 16 7"></polyline>
                      <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                    Logout
                  </button>
                </>
              ) : (
                <Link 
                  to="/register" 
                  className="btn-primary"
                  onClick={() => setShowMobileMenu(false)}
                  style={{ 
                    padding: '0.75rem 1rem', 
                    textAlign: 'center',
                    borderRadius: '8px',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    textDecoration: 'none',
                    display: 'block'
                  }}
                >
                  Get VIP Token
                </Link>
              )}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
